<template>
    <div class="fullcontainer p3bg6">
      <Back2FirstPage picposcls="picpos" />
      <MusicIcon picposcls="musicpos" />

      <div class="centerdiv">
        <img class="bg" src="res/p3/nwbz.png?1">

        <img class="centerpic" src="res/p3/ch.png">

        <img class="centerbtn heartpulse" src="res/p3/wcty.png" @click="complete">
      </div>
      
      
      
      
    </div> 
</template>

<script>
// import { url } from "@/d";
import Back2FirstPage from "./Back2FirstPage";
import MusicIcon from "./MusicIcon";

const components = { Back2FirstPage, MusicIcon };
export default {
  data() {
    return {
      // testurl: url("res/gz.png"),
    };
  },

  mounted() {
    // window.console.log("mounted。。。");
  },

  methods: {
    onClick() {
      // this.testinfo = "a";
      // this.$root.$emit("SwitchTo", "PageStack");
    },
     complete(){
      this.$root.$emit('P3SwitchTo','P3_1');
    },
  },

  components
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.p3bg6 {
  // @include centerbg; //'res/p1/bg.png'
  // background: url("../../public/res/p1/bg.png");
  .centerpic{
    top:3rem;
    width:72%;
    left: 13%;
  }
}
</style>
